import React, {Component} from 'react'
import {FormattedMessage, FormattedNumber} from "react-intl"

class DocumentPricingTableTotalWord extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            className: this.props.className || '',
            total: this.props.total || null,
            variables: this.props.variables || null,
            showTaxes: this.props.showTaxes === true,

        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            className: nextProps.className || '',
            total: nextProps.total || null,
            variables: nextProps.variables || null,
            showTaxes: nextProps.showTaxes === true,
        })
    }

    render() {
        let totals = []
        if (this.state.showTaxes) {
            totals.push(
                <tr key={totals.length}>
                    <td style={{textAlign:'right', width: '80%'}}>
                        <FormattedMessage
                            id="proposal.items.quote_sub_total"
                            defaultMessage="Sub Total"
                        />
                    </td>
                    <td style={{textAlign:'right', width: '20%'}}>
                        <FormattedNumber
                            style="currency"
                            currency={this.state.total.attributes.currency}
                            value={this.state.total.attributes.subtotalAmount}
                        />
                    </td>
                </tr>
            )

            if (this.state.total.attributes.isDiscounted) {
                totals.push(
                    <tr key={totals.length}>
                        <td style={{textAlign:'right', width: '80%'}}>
                            <FormattedMessage
                                id="proposal.items.quote_discount"
                                defaultMessage="Discount"
                            />
                        </td>
                        <td style={{textAlign:'right', width: '20%'}}>
                            <FormattedNumber
                                style="currency"
                                currency={this.state.total.attributes.currency}
                                value={-this.state.total.attributes.discountTotalAmount}
                            />
                        </td>
                    </tr>
                )
            }
            for (let i in this.state.total.attributes.taxCalculations) {
                const item = this.state.total.attributes.taxCalculations[i]
                totals.push(
                    <tr key={totals.length}>
                        <td style={{textAlign:'right', width: '80%'}}>
                            {item.attributes.taxComponent.attributes.name}
                        </td>
                        <td style={{textAlign:'right', width: '20%'}}>
                            <FormattedNumber
                                style="currency"
                                currency={this.state.total.attributes.currency}
                                value={item.attributes.taxAmount}
                            />
                        </td>
                    </tr>
                )
            }
            totals.push(
                <tr key={totals.length}>
                    <td style={{textAlign:'right', width: '80%'}}>
                        <FormattedMessage
                            id="proposal.items.quote_total"
                            defaultMessage="Total"
                        />
                    </td>
                    <td style={{textAlign:'right', width: '20%'}}>
                        <FormattedNumber
                            style="currency"
                            currency={this.state.total.attributes.currency}
                            value={this.state.total.attributes.totalAmount}
                        />
                    </td>
                </tr>
            )
        } else {
            if (this.state.total.attributes.isDiscounted) {
                totals.push(
                    <tr key={totals.length}>
                        <td style={{textAlign:'right', width: '80%'}}>
                            <FormattedMessage
                                id="proposal.items.quote_sub_total"
                                defaultMessage="Sub Total"
                            />
                        </td>
                        <td style={{textAlign:'right', width: '20%'}}>
                            <FormattedNumber
                                style="currency"
                                currency={this.state.total.attributes.currency}
                                value={this.state.total.attributes.subtotalAmount}
                            />
                        </td>
                    </tr>
                )
                totals.push(
                    <tr key={totals.length}>
                        <td style={{textAlign:'right', width: '80%'}}>
                            <FormattedMessage
                                id="proposal.items.quote_discount"
                                defaultMessage="Discount"
                            />
                        </td>
                        <td style={{textAlign:'right', width: '20%'}}>
                            <FormattedNumber
                                style="currency"
                                currency={this.state.total.attributes.currency}
                                value={-this.state.total.attributes.discountTotalAmount}
                            />
                        </td>
                    </tr>
                )

            }

            totals.push(
                <tr key={totals.length}>
                    <td style={{textAlign:'right', width: '80%'}}>
                        <FormattedMessage
                            id="proposal.items.quote_total"
                            defaultMessage="Total"
                        />
                    </td>
                    <td style={{textAlign:'right', width: '20%'}}>
                        <FormattedMessage
                            id="proposal.items.plus_taxes"
                            defaultMessage="{amount} + Taxes"
                            values={{
                                amount: <FormattedNumber
                                    style="currency"
                                    currency={this.state.total.attributes.currency}
                                    value={this.state.total.attributes.totalAmountWithoutTax}
                                />
                            }}
                        />
                    </td>
                </tr>
            )
        }
        if (this.state.total.attributes.billingMethod !== "one-time") {
            let label = <FormattedMessage
                id="proposal.total.per_month_label"
                defaultMessage="per month"
            />
            if (this.state.total.attributes.billingMethod === "yearly") {
                label = <FormattedMessage
                    id="proposal.total.per_year_label"
                    defaultMessage="per year"
                />
            }
            totals.push(
                <tr key={totals.length}>
                    <td />
                    <td style={{textAlign:'right'}}>
                        <small>{label}</small>
                    </td>
                </tr>
            )
        }

        return <table style={{
            width:'100%',
            fontFamily: this.state.variables.global.font + ', sans-serif',
            fontSize: '14px',
            padding: '5px',
        }}>
            <tbody>
                {totals}
            </tbody>
        </table>
    }
}

export default DocumentPricingTableTotalWord


// WEBPACK FOOTER //
// ./src/template/sections/content/pricing-table/wordtotal.component.jsx